import template from 'controls/back-in-stock-section.j2';

import { call } from 'redux-saga/effects';
import { mDom } from '../../../core/js/utils/renderUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';
import { getOptionsForUpdateButton } from '../../../core/js/utils/requestUtils';
import { updateButtonTextSaga } from '../../../core/js/sagas/animateButtonSagas';
import { backInStockNotificationSaga } from '../sagas/productBackInStockSagas';
import { backInStockView, saveFormValidation, backInStockNotificationFailure } from '../actions/productActions';
import { shouldActivateParsley, checkForm, isFormValid } from '../../../core/js/utils/errorHandling';
import { createGAEvent } from '../../../core/js/utils/analyticsUtils';
import { handleUtagEvent } from '../../../core/js/actions/initialActions';

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-back-in-stock-link'), (e) => {
        e.preventDefault();
        store.dispatch(backInStockView('signup', e, this));
        this.attachValidation(store, e, this);
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-back-in-stock-cancel'), (e) => {
        e.preventDefault();
        store.dispatch(backInStockView('link', e, this));
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-back-in-stock-submit'), (e) => {
        e.preventDefault();

        const formElement = $(this.scopedSelector('.js-back-in-stock-notification-form'));
        const valid = isFormValid(formElement);

        if (valid) {
            const emailAddress = $('#back-in-stock-email-address').val();
            const updateOptions = getOptionsForUpdateButton(store);

            const product = this.getTargetedProduct(store.getState());
            const brandAnalyticsSlug = _.get(product, 'analytics.productTypeSlug');
            const gaEvent = createGAEvent('pdp', brandAnalyticsSlug, 'back in stock - submit');

            let res = store.runSaga(updateButtonTextSaga, call(backInStockNotificationSaga, emailAddress, this), `.js-back-in-stock-submit`, 2000, updateOptions)
            .done.then(() => {
                store.dispatch(backInStockView('success', e, this));
                store.dispatch(handleUtagEvent(gaEvent, 'link'));
            }).catch((err) => {
                store.dispatch(backInStockNotificationFailure(err));
            });
        }
    });
}

/**
 * Bind parsley to the form
 * @param {object} store The store
 */
function attachValidation(store, event, component) {
    const formSelector = component.scopedSelector('.js-back-in-stock-notification-form');
    const formElement = $(formSelector);
    const parsleyForm = formElement.parsley();

    function activateValidation() {
        const [values, msgs] = checkForm('.js-back-in-stock-notification-form');
        store.dispatch(saveFormValidation(values, msgs, {}, component));
    }

    function activateFieldValidation() {
        if (parsleyForm && shouldActivateParsley(formElement)) {
            parsleyForm.on('field:validated', (e) => {
                activateValidation();
            });
        }
    }

    if (parsleyForm) {
        activateFieldValidation();

        parsleyForm.on('form:validate', (e) => {
            if (parsleyForm) {
                parsleyForm.off('field:validated');
            }
        });

        parsleyForm.on('form:validated', (e) => {
            activateValidation();
            activateFieldValidation();
        });
    }
}

function isBackInStockNotificationEnabled(store) {
    const product = this.getTargetedProduct(store.getState());
    const backInStockEnabled = _.get(product, 'backInStockEnabled', false);

    return backInStockEnabled;
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-product-back-in-stock-notification',
        attachEvents: attachEvents,
        attachValidation: attachValidation,
        onStateChange: onStateChange,
        forFamilyProduct: false,
        watch: 'product.productControls',
        template: template,
        renderType: mDom,
        name: 'productBackInStockComponent',
        isComponentValid: isBackInStockNotificationEnabled
    };

    return generate(config, store, overrides);
}
